import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

const ProtectedRoute = ({ requireRole }) => {
    const { isAuthenticated, isLoading, currentUser } = useAuth();

    if (isLoading) return null;
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    if (requireRole && currentUser?.role !== requireRole) return <Navigate to="/" replace />;

    return <Outlet />;
};

export default ProtectedRoute;
